import { AlertTriangleIcon, FlaskConicalIcon, SearchIcon, SettingsIcon, SlidersHorizontalIcon, WrenchIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '1',
    title: 'Fundamentals of Industrial Chemistry',
    summary: 'Chemistry principles, chemical reactions, thermodynamics, kinetics, mass/energy balances, raw materials, manufacturing fundamentals.',
    icon: WrenchIcon,
  },
  {
    number: '2',
    title: 'Unit Operations & Chemical Process Equipment',
    summary: 'Fluid mechanics, pumps, reactors, heat exchangers, separation technologies, mixing systems, solids processing, equipment reliability.',
    icon: SettingsIcon,
  },
  {
    number: '3',
    title: 'Industrial Chemical Production & Manufacturing Processes',
    summary: 'Inorganic/organic/polymer production, petrochemicals, specialty chemicals, production efficiency, emerging technologies.',
    icon: FlaskConicalIcon,
  },
  {
    number: '4',
    title: 'Process Control, Instrumentation & Industrial Automation',
    summary: 'Measurements, sensors, control valves, automation systems, process monitoring, alarms, advanced process control.',
    icon: SlidersHorizontalIcon,
  },
  {
    number: '5',
    title: 'Industrial Chemical Safety, Quality & Environmental Management',
    summary: 'Chemical hazards, risk assessment, safe handling, quality assurance, analytical chemistry, environmental protection.',
    icon: AlertTriangleIcon,
  },
  {
    number: '6',
    title: 'Chemical Process Optimization, Troubleshooting & Industrial Applications',
    summary: 'Performance indicators, process optimization, troubleshooting, root cause analysis, equipment reliability, industrial cases.',
    icon: SearchIcon,
  },
];
